import React, { useRef, ReactNode, MouseEvent } from "react";
import "./ToolTip.scss"; // You can define your styles in this CSS file

interface TooltipProps {
  children: ReactNode;
  content: string;
}

const Tooltip: React.FC<TooltipProps> = ({ children, content }) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  const showTooltip = (e: MouseEvent<HTMLDivElement>) => {
    if (tooltipRef.current) {
      const tooltip = tooltipRef.current;
      const tooltipWidth = tooltip.clientWidth;
      const tooltipHeight = tooltip.clientHeight;

      const viewportWidth = window.innerWidth;

      const mouseX = e.clientX;
      const mouseY = e.clientY;

      const tooltipLeft =
        mouseX + tooltipWidth + 10 < viewportWidth
          ? mouseX + 10
          : viewportWidth - tooltipWidth - 5;

      const tooltipTop =
        mouseY - tooltipHeight - 10 > 0
          ? mouseY - tooltipHeight - 10
          : mouseY + 10;

      tooltip.style.left = `${tooltipLeft}px`;
      tooltip.style.top = `${tooltipTop}px`;
    }
  };

  return (
    <span className="tooltip-container">
      <span className="tt-trigger" onMouseMove={showTooltip}>
        {children}
      </span>
      <span className="tooltip" ref={tooltipRef}>
        {content}
      </span>
    </span>
  );
};

export default Tooltip;
